import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { getCollapse, setCollapse } from '../storage.service';

export class CollapseService {
  collapse = new BehaviorSubject(false);
  collapsable = new BehaviorSubject(true);
  fullPage = new BehaviorSubject(false);

  constructor() {
    this.collapse.next(getCollapse() || false);
  }

  get collapse$() {
    return this.collapse.asObservable();
  }

  get collapsable$() {
    return this.collapsable.asObservable();
  }

  get fullPage$() {
    return this.fullPage.asObservable();
  }

  toggleCollapse() {
    const collapse = !this.collapse.getValue();

    this.collapse.next(collapse);
    setCollapse(collapse);
  }

  collapseAndStore() {
    this.collapse.next(true);
    this.collapsable.next(false);
  }

  restoreCollapsed() {
    this.collapse.next(false);
    this.collapsable.next(true);
  }

  enterFullPage(isDesktop) {
    if (isDesktop) {
      this.fullPage.next(true);
      this.collapseAndStore();
    }
  }

  exitFullPage() {
    this.fullPage.next(false);
    this.restoreCollapsed();
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/visual/collapse.service.ts